(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gadgetmivo-order-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gm-order-now')) {
customElements.define('gm-order-now', class extends HTMLElement {
connectedCallback() {
if(this.ready) return; this.ready=true;
const button=this.querySelector('button'),error=this.querySelector('[role="alert"]');
button.addEventListener('click',async()=>{
const form=document.getElementById(this.dataset.form);
if(!form) return;
const variant=form.querySelector('[name="id"]');
if(!variant || variant.disabled || !variant.value){error.textContent=button.dataset.error;error.hidden=false;return;}
const label=button.textContent;
button.disabled=true;button.textContent=button.dataset.loading;error.hidden=true;
try{
const data=new FormData(form);data.delete('sections');data.delete('sections_url');
const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
const body=await response.json();
if(!response.ok) throw new Error(body.description||button.dataset.error);
window.location.assign(window.Shopify.routes.root+'checkout');
}catch(e){error.textContent=e.message||button.dataset.error;error.hidden=false;button.disabled=false;button.textContent=label;}
});
}
});
}
  } catch(e) { console.error(e); }
})();

})();
